/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Action } from '@ngrx/store';
import { Department } from '@shared/models';

export const LOAD_DEPARTMENTS = '[Departments] Load';
export const LOAD_DEPARTMENTS_SUCCESS = '[Departments] Load success';
export const LOAD_DEPARTMENTS_FAILURE = '[Departments] Load failure';
export const EDIT_DEPARTMENT = '[Department] Edit';
export const LOAD_DEPARTMENT = '[Department] Load';
export const LOAD_DEPARTMENT_SUCCESS = '[Department] Load success';
export const LOAD_DEPARTMENT_FAILURE = '[Department] Load failure';
export const PERSIST_DEPARTMENT = '[Department] Persist';
export const PERSIST_DEPARTMENT_SUCCESS = '[Department] Persist success';
export const PERSIST_DEPARTMENT_FAILURE = '[Department] Persist failure';
export const DELETE_DEPARTMENT = '[Department] Delete';
export const DELETE_DEPARTMENT_SUCCESS = '[Department] Delete success';
export const DELETE_DEPARTMENT_FAILURE = '[Department] Delete failure';

export class LoadDepartments implements Action {
  readonly type = LOAD_DEPARTMENTS;
}

export class LoadDepartmentsSuccess implements Action {
  readonly type = LOAD_DEPARTMENTS_SUCCESS;
  constructor(public departments: Department[]) { }
}

export class LoadDepartmentsFailure implements Action {
  readonly type = LOAD_DEPARTMENTS_FAILURE;
}

export class EditDepartment implements Action {
  readonly type = EDIT_DEPARTMENT;
  constructor(public departmentId?: string) { }
}

export class LoadDepartment implements Action {
  readonly type = LOAD_DEPARTMENT;
  constructor(public departmentId?: string) { }
}

export class LoadDepartmentSuccess implements Action {
  readonly type = LOAD_DEPARTMENT_SUCCESS;
  constructor(public department: Department) { }
}

export class LoadDepartmentFailure implements Action {
  readonly type = LOAD_DEPARTMENT_FAILURE;
}

export class PersistDepartment implements Action {
  readonly type = PERSIST_DEPARTMENT;
  constructor(public department: Department) { }
}

export class PersistDepartmentSuccess implements Action {
  readonly type = PERSIST_DEPARTMENT_SUCCESS;
}

export class PersistDepartmentFailure implements Action {
  readonly type = PERSIST_DEPARTMENT_FAILURE;
  constructor(public message?: string) { }
}

export class DeleteDepartment implements Action {
  readonly type = DELETE_DEPARTMENT;
  constructor(public departmentId: string) { }
}

export class DeleteDepartmentSuccess implements Action {
  readonly type = DELETE_DEPARTMENT_SUCCESS;
}

export class DeleteDepartmentFailure implements Action {
  readonly type = DELETE_DEPARTMENT_FAILURE;
  constructor(public message?: string) { }
}

export type DepartmentsActions = LoadDepartments | LoadDepartmentsSuccess | LoadDepartmentsFailure |
  EditDepartment | LoadDepartment | LoadDepartmentSuccess | LoadDepartmentFailure |
  PersistDepartment | PersistDepartmentSuccess | PersistDepartmentFailure |
  DeleteDepartment | DeleteDepartmentSuccess | DeleteDepartmentFailure;
